import PropTypes from 'prop-types';
import merge from 'lodash/merge';
import { useMemo } from 'react';
// @mui
import { alpha, ThemeProvider, createTheme, useTheme } from '@mui/material/styles';
//
import { useSettingsContext } from './SettingsContext';

// ----------------------------------------------------------------------

ThemeColorPresets.propTypes = {
  children: PropTypes.node,
};

export default function ThemeColorPresets({ children }) {
  const outerTheme = useTheme();

  const { presetsColor } = useSettingsContext();

  const safePreset =
    typeof presetsColor === 'string'
      ? { main: presetsColor }
      : presetsColor || { main: '#2065D1' }; // fallback color

  const themeOptions = useMemo(
    () => ({
      palette: {
        primary: { main: safePreset.main },
      },
      customShadows: {
        primary: `0 8px 16px 0 ${alpha(safePreset.main, 0.24)}`,
      },
    }),
    [safePreset.main]
  );

  const theme = createTheme(merge(outerTheme, themeOptions));

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
